import { VisitsGeocodedDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';

export default ({ store, visits }: VisitsGeocodedDtoModelType) => () => {
  const rootStore = getAppRoot(store);
  const projectId = rootStore.ui.selectedWorkspace?.id;
  if (visits != null && projectId != null) {
    // todo: Replace with VisitDto vs VisitLatLngDto?, with active, bestMatch already
    // rootStore.model.applyGeocodedVisits(projectId, visits);
  }
};
